import React from 'react';
import { IconProps } from './IconTypes';

const TianheLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6,28 C20,16 32,40 50,28 C68,16 80,40 94,28 L94,42 C80,54 68,30 50,42 C32,54 20,30 6,42 Z" />
      <path d="M6,52 C20,40 32,64 50,52 C68,40 80,64 94,52 L94,66 C80,78 68,54 50,66 C32,78 20,54 6,66 Z" />
      <path d="M6,76 C20,64 32,88 50,76 C68,64 80,88 94,76 L94,90 C80,102 68,78 50,90 C32,102 20,78 6,90 Z" />
    </svg>
  );
};

export default TianheLogo;
